// ============================================================================
// AdminSeriesPanel — top-level Series and Templates section.
// ============================================================================
// Loads the series list and renders SeriesManageModal in inline mode so the
// existing CRUD + Materialize functionality is available without opening a
// modal overlay. Wired into AdminLayout via the #admin/series route.
// ============================================================================

import { useCallback, useEffect, useState } from 'react';
import { api, type Series } from '../api';
import { SeriesManageModal } from './SeriesManageModal';

interface Props {
  token: string;
}

export function AdminSeriesPanel({ token }: Props) {
  const [series, setSeries] = useState<Series[]>([]);
  const [error, setError] = useState('');

  const refresh = useCallback(() => {
    api.series()
      .then((d) => setSeries(d.series))
      .catch((err) => setError(err?.message || 'Could not load series.'));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Series and templates</h1>
        <p className="text-sm text-gray-600 mt-0.5">
          Manage recurring patterns. Link a template event to a series, then click
          Materialize to generate occurrences.
        </p>
      </div>

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 rounded-md px-3 py-2 text-sm">
          {error}
        </div>
      )}

      <SeriesManageModal
        open={true}
        inline={true}
        onClose={() => {}}
        token={token}
        series={series}
        onRefresh={refresh}
      />
    </div>
  );
}
